import { Stack, styled, Typography } from '@mui/material';
import { useMediaQuery, Theme } from '@mui/material';
import VerticalDivider from '../../../assets/divider-vertical.png';
import { CONNECT_JOBBOARD_STATES, WAITLIST_STATES } from 'utils/constants/connect';
import { candidatePortalRoutes } from 'utils/constants/urls';
import { getStateLabel } from 'features/Connect/features/JobDiscovery/utils';
import { CandidateNavBarLogoProps } from '../types';
import { LogoLink } from '../NavBarLogos/styles';
import { NimbleLogo } from '../NavBarLogos/NimbleLogo';
import { StateDOELogo } from '../NavBarLogos/StateDOELogo';
import { useRouteMatch } from 'react-router-dom';
import { PoweredByNimbleLogo } from '../NavBarLogos/PoweredByNimbleLogo';

export const CandidateNavBarLogoContainer: React.FC<CandidateNavBarLogoProps> = ({
  jobBoardState,
  connectUrlPath,
}) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const isSmallTablet = useMediaQuery((theme: Theme) => theme.breakpoints.down('mdlg'));
  const isCandidatePortal = useRouteMatch({
    path: candidatePortalRoutes.CANDIDATE_PORTAL,
  });
  const formattedJobBoardState = jobBoardState?.toLowerCase();

  const getLogoComponent = () => {
    if (isCandidatePortal) {
      return <PoweredByNimbleLogo isMobile={isMobile} />;
    }

    if (jobBoardState && CONNECT_JOBBOARD_STATES[jobBoardState]?.logo) {
      return <StateDOELogo jobBoardState={jobBoardState} isMobile={isMobile} />;
    }
    return <NimbleLogo isMobile={isMobile} />;
  };

  const showTitle =
    !(isMobile || isSmallTablet) && !!CONNECT_JOBBOARD_STATES[jobBoardState] && !isCandidatePortal;

  const isLogoUnclickable = WAITLIST_STATES.includes(formattedJobBoardState);

  const logoElement = getLogoComponent();

  return (
    <Stack direction="row" gap={2} alignContent="center">
      {isLogoUnclickable ? (
        <LogoContainer>{logoElement}</LogoContainer>
      ) : (
        <LogoLink href={connectUrlPath}>{logoElement}</LogoLink>
      )}
      {showTitle && (
        <>
          <DividerImage src={VerticalDivider} alt="vertical divider" />
          <Stack direction={'column'} alignSelf={'center'}>
            <JobSearchTitle>{`Official Educator Job Board`}</JobSearchTitle>
            <JobSearchTitle>{`for the State of ${getStateLabel(jobBoardState)}`}</JobSearchTitle>
          </Stack>
        </>
      )}
    </Stack>
  );
};

const JobSearchTitle = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.body2.fontSize,
  color: theme.palette.text.tertiary,
  lineHeight: theme.typography.h2.lineHeight,
}));

const DividerImage = styled('img')(() => ({
  height: '56px',
  width: 'auto',
  objectFit: 'contain',
}));

const LogoContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
}));
